import { render, staticRenderFns } from "./dislike.vue?vue&type=template&id=231922a5&"
import script from "./dislike.vue?vue&type=script&lang=js&"
export * from "./dislike.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('231922a5')) {
      api.createRecord('231922a5', component.options)
    } else {
      api.reload('231922a5', component.options)
    }
    module.hot.accept("./dislike.vue?vue&type=template&id=231922a5&", function () {
      api.rerender('231922a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/dislike.vue"
export default component.exports